import { FilterDefinitionType, FilterType } from "@/components/@types";
import { FieldEnum } from "@/components/organisms/Field/FieldEnum";
import { Utils } from "@/utils";

export function FilterChipValueContent({
  filter,
  filterDefinition,
}: {
  filter: FilterType;
  filterDefinition: FilterDefinitionType;
}) {
  if (!filter.value) {
    return <>Enter {filterDefinition.type}...</>;
  }

  switch (filter.type) {
    case "date":
      if (filter.operator === "range") {
        return (
          <>
            {filter.value.date1 && Utils.fDate(new Date(filter.value.date1))}
            {!filter.value.date1 && "Enter " + filterDefinition.type + "..."}
            {" → "}
            {filter.value.date2 && Utils.fDate(new Date(filter.value.date2))}
            {!filter.value.date2 && "Enter " + filterDefinition.type + "..."}
          </>
        );
      }
      return (
        <>{filter.value.date1 && Utils.fDate(new Date(filter.value.date1))}</>
      );

    case "text":
    case "number":
    case "currency":
      return <>{filter.value}</>;

    case "reference":
      return (
        <span className="pl-1 pr-1 rounded bg-secondary">
          {Array.isArray(filter.value) ? (
            <>{filter.value.length} selected</>
          ) : (
            <>1 selected</>
          )}
        </span>
      );

    case "enum":
      if (Array.isArray(filter.value)) {
        return <>{filter.value.length} selected</>;
      }
      return (
        <FieldEnum
          value={filter.value}
          valueOptions={filterDefinition.getValueOptions(undefined) as any}
          isMultiline={false}
          style={{ paddingLeft: 0, paddingRight: 0 }}
        />
      );

    default:
      return null;
  }
}
